import React, { Component } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import "./styles.scss";
import axios from "axios";
import ReactPlayer from "react-player";
import { Button } from "@material-ui/core";

class SeoWizard extends Component {
  constructor() {
    super();
    this.state = {
      url: "",
      keyword: "",
      pageTitle: "",
      pageMeta: "",
      canonicalUrl: ""
    };
    this.urlChange = this.urlChange.bind(this);
    this.keywordChange = this.keywordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getImageBannerUrl = id => {
    let url = "";
    this.props.location.state.assetData.map(data => {
      if (id === data.sys.id) {
        url = data.fields.file.url;
      }
    });
    return url;
  };

  handleSubmit(e) {
    e.preventDefault();
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}" + // domain name
      "\\s*|" +
      "((\\d{1,3}\\.){  3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    if (this.state.keyword !== "" && !!pattern.test(this.state.url)) {
      var url = this.state.url;
      url = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split("/")[0];
      this.props.history.push({
        pathname: `/seo-wizard/${url}`,
        url: url,
        keyword: this.state.keyword
      });
    }
  }

  componentDidMount() {
    // axios
    //   .get(
    //     "https://cdn.contentful.com/spaces/e9ct5l4tkfzk/entries/1QPcMoDZPqN93M0g3QnXD8?access_token=fEOA44KcxnNFrwl5gBfMP-Fea6ouBZE0gSOiOZdCaxA"
    //   )
    //   .then(res => {
    //     this.setState({ pageMeta: res.data.fields.pageMeta });
    //     this.setState({ pageTitle: res.data.fields.pageTitle });
    //     this.setState({ canonicalUrl: res.data.fields.canonicalUrl });
    //   });
    // axios
    //   .get(
    //     "https://cdn.contentful.com/spaces/e9ct5l4tkfzk/entries?access_token=fEOA44KcxnNFrwl5gBfMP-Fea6ouBZE0gSOiOZdCaxA&content_type=team"
    //   )
    //   .then(res => {
    //     this.setState({
    //       team: res.data.items,
    //       assetData: res.data.includes
    //     });
    //     // console.log(this.state.assetData[0].fields.file.url);
    //   });
  }

  urlChange = e => {
    if (e.key === "Enter") {
      this.findButton.click();
    }
    this.setState({
      url: e.target.value
    });
  };

  keywordChange = e => {
    if (e.key === "Enter") {
      this.findButton.click();
    }
    this.setState({
      keyword: e.target.value
    });
  };

  render() {
    const { url, keyword } = this.state;
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title> {this.state.pageTitle} </title>
          <meta name="description" content={this.state.pageMeta} />
          <link rel="canonical" href={this.state.canonicalUrl} />
        </Helmet>

        <div className="topicfinder">
          <div className="container row">
            <div className="col-12 col-xl-6 d-flex flex-column justify-content-center">
              <div className="topicfinder__underline " />
              <p className="topicfinder__title">On-Page SEO Wizard</p>
              <p className="topicfinder__text">
                Waht keyword do you want ot rank for? We’ll help you edit your
                page to ensure the ideal audience finds your client on Google.
              </p>
            </div>
            <div className="col-12 col-xl-6">
              <ReactPlayer
                url="https://www.youtube.com/watch?v=W-oQ58CAYFU"
                // url={this.findVideoUrl(video)}
                playing
                muted
                loop
                className="topicfinder__video"
              />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="topicFinderBody">
            <p className="topicFinderBody__title">Hi there!</p>
            <p className="topicFinderBody__text">What is your web page URL?</p>
            <input
              type="text"
              className="topicFinderBody__input"
              placeholder="your domain.com/web-page-name"
              value={url}
              onKeyPress={this.urlChange}
              onChange={this.urlChange}
            />

            <p className="topicFinderBody__text">
              What is the keyword you want to rank for?
            </p>
            <input
              type="text"
              className="topicFinderBody__input"
              placeholder="your great keyword."
              value={keyword}
              onKeyPress={this.keywordChange}
              onChange={this.keywordChange}
            />
            <div
              className="topicFinderBodyNext row d-flex justify-content-end"
              onClick={this.handleSubmit}
              ref={el => (this.findButton = el)}
            >
              <Button className=" col-4 col-sm-10 col-md-8 col-lg-6 col-xl-4">
                <span className="topicFinderBodyNext__text">
                  Show SEO Suggestions
                </span>
                <img
                  style={{ height: "14px", margin: "0 0 0 0px" }}
                  src={require("../../assets/SVG/right-arrow1.svg")}
                  alt=""
                />
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SeoWizard;
